import Utility from '@/common/UtilityFunctions.js';

const arr = [];
let i;
let j;
for (i = 0; i < 24; i++) {
  for (j = 0; j < 4; j++) {
    arr.push(Utility.leadingZero(i) + ':' + (j === 0 ? '00' : 15 * j));
  }
}

export default arr;
